import { AxiosError } from 'axios';

class ApiErrorParser {
  constructor(public error: any) {}

  toString() {
    return this.formatError(this.error);
  }

  formatError(arg: any) {
    if ((arg as AxiosError)?.isAxiosError) {
      const a = arg as AxiosError<any>;
      if (!a.response) {
        if (
          a.message === 'Network Error' ||
          a.code === 'ERR_NETWORK' ||
          a.code === 'ECONNABORTED'
        ) {
          return 'Tidak dapat terhubung ke jaringan. Periksa koneksi internet Anda.';
        }
        return a.message;
      }
      if (a?.response?.data?.message) {
        if (Array.isArray(a.response.data.message)) {
          const errorMsg = a.response.data.message.map((m: any) => m).join('\n');
          switch (errorMsg.toLowerCase()) {
            case 'email must be an email':
              return 'Silakan masukkan email dengan benar';
            case 'please enter phone number correctly':
              return 'Silakan masukkan nomor telepon dengan benar';
            case 'account not found':
              return false;
            default:
              return errorMsg;
          }
        } else if (a.response?.data?.statusCode === 404) {
          return false;
        } else if (
          a.response?.data?.statusCode === 409 &&
          a.response?.data?.error?.toLowerCase() === 'conflict' &&
          a.response?.data?.message?.toLowerCase() === 'username / email and its credential exist'
        ) {
          return 'Akun telah terdaftar';
        } else if (
          a.response?.data?.statusCode === 400 &&
          a.response?.data?.error?.toLowerCase() === 'bad request' &&
          a.response?.data?.message?.toLowerCase() === 'account not found'
        ) {
          return false;
        } else if (
          a.response?.data?.statusCode === 409 &&
          a.response?.data?.name?.toLowerCase() === 'conflicterror' &&
          a.response?.data?.message?.toLowerCase() === 'maximum idr account number reached'
        ) {
          return false;
        } else if (
          a.response?.data?.statusCode === 401 &&
          a.response?.data?.message?.toLowerCase() === 'unauthorized'
        ) {
          return false;
        } else if (
          a.response?.data?.statusCode === 404 &&
          a.response?.data?.message?.toLowerCase() === 'account not found'
        ) {
          return false;
        } else {
          return a.response.data.message;
        }
      } else {
        return a.message;
      }
    } else if (arg instanceof Error) {
      return arg.message;
    } else if (typeof arg === 'string') {
      return arg;
    }
  }
}

export default ApiErrorParser;
